import React from 'react'
import PropTypes from 'prop-types'
import FieldExtra from '../FieldExtra';
import './radioButton.scss'

const RadioButton = ({children, error, warning, checked, disabled, className, disabledTitle, ...rest}) => {
  return (<div className="Suc-radio-container">
      <label
        className={`Suc-radio-button ${disabled ? 'Suc-disabled' : ''} ${checked ? 'Suc-active' : ''} ${className}`}
        title={disabled ? disabledTitle : ''}>
        <input className={'Suc-radio-input'} checked={checked} type="radio" disabled={disabled} {...rest}/>
        <svg>
          <circle stroke="1" cx="8.5" cy="8.5" r="8" className={'Suc-outer-circle'}/>
          <circle stroke="none" cx="8.5" cy="8.5" r="1" className={'Suc-inner-circle'}/>
        </svg>
        {children}
      </label>
      <FieldExtra error={error} warning={warning}/>
    </div>
  )
}

RadioButton.propTypes = {
  /** checked or unchecked */
  checked: PropTypes.bool,
  /** disabled state */
  disabled: PropTypes.bool,
  /** custom classname */
  className: PropTypes.string,
  /** radio option label */
  children: PropTypes.node,
  /** callback run on change */
  onChange: PropTypes.func,
  /** if disabled show tooltip with explanation */
  disabledTitle: PropTypes.node
}

RadioButton.defaultProps = {
  className: '',
  disabled: false
}

export default RadioButton
